import * as React from 'react';
import { Checkbox as AntdCheckbox } from 'antd';
import { CheckboxProps as AntdCheckboxProps } from 'antd/lib/checkbox';
import { AppContext } from '@/utils/appProvider';
import classnames from 'classnames';
import './index.less';

export interface CheckboxProps extends AntdCheckboxProps {}

const Checkbox: React.FC<CheckboxProps> = props => {
  const { children, className } = props;
  const { prefixCls } = React.useContext(AppContext);

  return (
    <AntdCheckbox {...props} className={classnames(`${prefixCls}-checkbox`, className)}>
      {children}
    </AntdCheckbox>
  );
};

export default Checkbox;
